export const MAIN_CLASS = 'OfferMap';

export const VIEW_MAP = 'MAP';
export const VIEW_PANORAMA = 'PANORAMA';

export const ZOOM_MIN = 2;
export const ZOOM_MAX = 17;
export const ZOOM = 14;
